import { SiteInfo } from "./siteAboutInterfaces";

export type NatWireguardFieldUpdates = Partial<
  Pick<SiteInfo, "wireguard" | "ecs_nat_instance">
>;

export const WIREGUARD_OVER_NAT_MESSAGE =
  "Enabling WireGuard will DISABLE the NAT (Whitelisting) for this site and cameras will need to be edited accordingly to connect through WireGuard. Do you wish to proceed?";

export const NAT_OVER_WIREGUARD_MESSAGE =
  "Enabling NAT whitelisting will DISABLE WireGuard for this site and cameras will need to be edited accordingly to connect through NAT. Do you wish to proceed?";

export const areNatAndWireguardFieldsVisible = (
  siteInfo: Pick<SiteInfo, "show_ecs_nat_instance" | "display_wireguard">,
  showWireguardFlag: boolean
): boolean =>
  Boolean(siteInfo.show_ecs_nat_instance) &&
  showWireguardFlag &&
  Boolean(siteInfo.display_wireguard);

export const shouldPromptWireguardOverNat = (
  siteInfo: Pick<SiteInfo, "ecs_nat_instance" | "wireguard">
): boolean =>
  siteInfo.ecs_nat_instance === true && siteInfo.wireguard == null;

export const shouldPromptNatOverWireguard = (
  siteInfo: Pick<SiteInfo, "ecs_nat_instance" | "wireguard">,
  natChecked: boolean
): boolean =>
  natChecked === true &&
  siteInfo.ecs_nat_instance === false &&
  siteInfo.wireguard != null;

export const applyWireguardOverNat = (
  wireguardId: number
): NatWireguardFieldUpdates => ({
  wireguard: wireguardId,
  ecs_nat_instance: false,
});

export const applyNatOverWireguard = (): NatWireguardFieldUpdates => ({
  ecs_nat_instance: true,
  wireguard: null,
});
